import { Option } from "../models/option.model";

/**
 * PURPOSE: houses the list of US state codes and display names
 */

export abstract class UsStates {
  public static states: Option[] = [
    { id: 1, field: "AL", displayName: "Alabama" },
    { id: 2, field: "AK", displayName: "Alaska" },
    { id: 3, field: "AZ", displayName: "Arizona" },
    { id: 4, field: "AR", displayName: "Arkansas" },
    { id: 5, field: "CA", displayName: "California" },
    { id: 6, field: "CO", displayName: "Colorado" },
    { id: 7, field: "CT", displayName: "Connecticut" },
    { id: 8, field: "DE", displayName: "Delaware" },
    { field: "DC", displayName: "District of Columbia" }, // No ID for DC
    { id: 9, field: "FL", displayName: "Florida" },
    { id: 10, field: "GA", displayName: "Georgia" },
    { id: 11, field: "HI", displayName: "Hawaii" },
    { id: 12, field: "ID", displayName: "Idaho" },
    { id: 13, field: "IL", displayName: "Illinois" },
    { id: 14, field: "IN", displayName: "Indiana" },
    { id: 15, field: "IA", displayName: "Iowa" },
    { id: 16, field: "KS", displayName: "Kansas" },
    { id: 17, field: "KY", displayName: "Kentucky" },
    { id: 18, field: "LA", displayName: "Louisiana" },
    { id: 19, field: "ME", displayName: "Maine" },
    { id: 20, field: "MD", displayName: "Maryland" },
    { id: 21, field: "MA", displayName: "Massachusetts" },
    { id: 22, field: "MI", displayName: "Michigan" },
    { id: 23, field: "MN", displayName: "Minnesota" },
    { id: 24, field: "MS", displayName: "Mississippi" },
    { id: 25, field: "MO", displayName: "Missouri" },
    { id: 26, field: "MT", displayName: "Montana" },
    { id: 27, field: "NE", displayName: "Nebraska" },
    { id: 28, field: "NV", displayName: "Nevada" },
    { id: 29, field: "NH", displayName: "New Hampshire" },
    { id: 30, field: "NJ", displayName: "New Jersey" },
    { id: 31, field: "NM", displayName: "New Mexico" },
    { id: 32, field: "NY", displayName: "New York" },
    { id: 33, field: "NC", displayName: "North Carolina" },
    { id: 34, field: "ND", displayName: "North Dakota" },
    { id: 35, field: "OH", displayName: "Ohio" },
    { id: 36, field: "OK", displayName: "Oklahoma" },
    { id: 37, field: "OR", displayName: "Oregon" },
    { id: 38, field: "PA", displayName: "Pennsylvania" },
    { id: 39, field: "RI", displayName: "Rhode Island" },
    { id: 40, field: "SC", displayName: "South Carolina" },
    { id: 41, field: "SD", displayName: "South Dakota" },
    { id: 42, field: "TN", displayName: "Tennessee" },
    { id: 43, field: "TX", displayName: "Texas" },
    { id: 44, field: "UT", displayName: "Utah" },
    { id: 45, field: "VT", displayName: "Vermont" },
    { id: 46, field: "VA", displayName: "Virginia" },
    { id: 47, field: "WA", displayName: "Washington" },
    { id: 48, field: "WV", displayName: "West Virginia" },
    { id: 49, field: "WI", displayName: "Wisconsin" },
    { id: 50, field: "WY", displayName: "Wyoming" }
  ];

  public static getStateName(stateCode: string): string | undefined {
    return this.states.find((state) => state.field === stateCode)?.displayName;
  }

  public static getStateId(stateCode: string): number | undefined {
    return this.states.find((state) => state.field === stateCode)?.id;
  }

  public static getAllStateNames(): string[] {
    return this.states.map((state) => state.displayName);
  }
}
